module.exports = __webpack_public_path__ + "img/YT.70bd9267.svg";